<template>
	<div class="tabExport">
		<div>
			<el-select v-model="dateSelected" placeholder="Choisir la semaine" clearable>
				<el-option v-for="item in weeks" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-button @click.native.prevent="generateCsvFile(dateSelected)" type="warning" size="small" class="btnGenerateCsv">
				<i class="fas fa-file-csv iconOperationCsv"> Générer le .CSV</i>
			</el-button>
		</div>
		<el-table v-loading="loading" :data="tableExport" >
			<el-table-column fixed label="#" width="90">
				<template slot-scope="scope">
					{{ ((scope.$index+1)+(currentPage-1)*10) }}
				</template>
			</el-table-column>
			<el-table-column label="Période">
				<template slot-scope="scope">
					{{ scope.row.year+" semaine "+scope.row.week }}
				</template>
			</el-table-column>
			<el-table-column label="Nom du fichier">
				<template slot-scope="scope">
					{{ scope.row.name }}
				</template>
			</el-table-column>
			<el-table-column label="Nb écriture">
				<template slot-scope="scope">
					{{ scope.row.lines }}
				</template>
			</el-table-column>
			<el-table-column label="Généré le">
				<template slot-scope="scope">
					{{ getDateTime(scope.row.generated) }}
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="Opérations" width="120">
				<template slot-scope="scope">
					<a :href="'/api/downloadExportVenteJePilote/'+scope.row.name" download>
						<i class="fas fa-file-download iconOperationDownload"></i>
					</a>
					<el-button @click.native.prevent="deleteRow(scope.row.name)" type="text" size="small">
						<i class="far fa-trash-alt iconOperationDelete"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination layout="prev, pager, next" :page-size="10" :total="dataExportLength" :current-page.sync="currentPage"></el-pagination>
	</div>
</template>

<script>
var moment = require('moment');
import script from '../../../../script/script.js';
import scriptComptabilite from '../../../../script/script_comptabilite';
export default {
	data () {
		return {
			dateSelected:'',
			dataExport:[],
			currentPage: 1,
			dataExportLength:null,
			loading:true
		}
	},
	methods: {
		getExportVenteJePilote: scriptComptabilite.getExportVenteJePilote,
		delExportVenteJePilote: scriptComptabilite.delExportVenteJePilote,
		generateCsv: scriptComptabilite.generateCsv,
		async generateCsvFile(date){
			this.loading = true
			await this.generateCsv(date)
			this.getExportVenteJePilote('export','.csv')
			this.loading = false
		},
		async deleteRow(name) {
			await this.delExportVenteJePilote(name)
			this.getExportVenteJePilote('export','.csv')
		},
		getStartDateWeek(i){
			let startDate = null
			let j = 1
			var find = false
			while (!find) {
				if(moment().subtract(i,'w').week() != moment().subtract(i,'w').subtract(j,'d').week()){
					startDate = moment().subtract(i,'w').subtract(j-1,'d').startOf('day')
					find=true
				}else{
					j++
				}
			}
			return startDate
		},
		getEndDateWeek(i){
			let endDate = null
			let k = 1
			var find = false
			while (!find){
				if(moment().subtract(i,'w').week() != moment().subtract(i,'w').add(k,'d').week()){
					endDate = moment().subtract(i,'w').add(k-1,'d').startOf('day')
					find=true
				}else{
					k++
				}
			}
			return endDate
		},
		getDateTime(tms){
			var date = moment.unix(tms)
			return date.format('DD/MM/YYYY à HH:mm:ss')
		},
    },
	computed:{
		weeks(){
			let weeks = []
			for(var i = 1; i < 12; i++){
				let startDate = this.getStartDateWeek(i)
				let endDate = this.getEndDateWeek(i)
				if(moment().subtract(i,'w').week() == 1){
					weeks.push({value:moment().year()+'-'+moment().subtract(i,'w').week()+'|'+startDate.format('YYYY-MM-DDTHH:mm:ss')+'|'+endDate.format('YYYY-MM-DDTHH:mm:ss'), label:moment().year()+' - Semaine '+moment().subtract(i,'w').week()+' ('+startDate.format('L')+'...)'})
				}else{
					weeks.push({value:moment().subtract(i,'w').year()+'-'+moment().subtract(i,'w').week()+'|'+startDate.format('YYYY-MM-DDTHH:mm:ss')+'|'+endDate.format('YYYY-MM-DDTHH:mm:ss'), label:moment().subtract(i,'w').year()+' - Semaine '+moment().subtract(i,'w').week()+' ('+startDate.format('L')+'...)'})
				}
			}
			return weeks
		},
		tableExport(){
			this.loading = false
			return this.dataExport[this.currentPage-1]
		}
	},
	mounted: function(){
		this.getExportVenteJePilote('export','.csv')
	}
}
</script>

<style>
.iconOperationDownload{
	font-size: 1.5em;
	color: green;
}

.iconOperationCsv{
	font-size: 1.5em;
}

.iconOperationDelete{
	font-size: 1.5em;
	color: red;
}

.tabExport{
	display: flex;
    flex-direction: column;
    justify-content: center;
    width: 75%;
    align-items: center;
	margin: auto;
	padding-top: 1em;
}

.btnGenerateCsv{
	margin-left: .5em;
}
</style>